import React, { useEffect, useState } from 'react'
import { useStyle } from "./Style";
import { getPartner, getPartnerGuid, getUserEmail, getUserFullname } from '../../../../../lib/access.es6';
import AlertDialog from '../../../../../components/AlertDialog/index.es6';
import { CircularProgress } from '@material-ui/core';
import { Button } from '@mui/material';
import { find } from 'lodash';
import SelectPlan from './SelectPlan/index';
import SelectCoverType from './SelectCoverType';
import SelectRelationship from './SelectRelationship';
import NavButtons from './NavButtons';
import AddBenefits from './AddBenefits';
import ViewMembers from './ViewMembers';
import Adddependant from './AddDependant';
import { COMPONENT_TYPES, isExtendedMember } from '../../helpers';
import posthog from 'posthog-js';


const CreateQuoteMonamodi = (props) => {
  const classes = useStyle();

  const [currentComponent, setCurrentComponent] = useState(COMPONENT_TYPES.SELECT_COVER_TYPE);
  const [coverType, setCoverType] = useState(null);
  const [selectedPlan, setPlan] = useState(null);
  const [parentsPlan, setParentsPlan] = useState(null);
  const [hasParentsPlan, setHasParentsPlan] = useState(null)

  const [currentRelationShip, setCurrentRelationShip] = useState(null)
  const [lastSelectedExtendedRelationship, setLastSelectedExtendedRelationship] = useState(null)
  const [memberRelationshipType, setMemberRelationshipType] = useState(null)

  const [openAddBenefitsDialog, setOpenAddBenefitsDialog] = useState(null)
  const [selectedExtendedBenefit, setSelectedExtendedBenefit] = useState(null)

  const [suspendDuplicateIdCheck, setSuspendDuplicateIdCheck] = useState(false)


  const [togglequoteanddependant, settogglequoteanddependant] = useState(true)
  const [dependants, setDependants] = useState([])
  const [depAlert, setDepAlert] = useState(false);

  const [additionalBenefits, setAdditionalBenefits] = useState({})



  // useEffect(() => {
  //   console.log('actionParam: ', props.actionParam);
  //   if (props.actionParam === 'upgrade-downgrade') {
  //     setCurrentComponent(COMPONENT_TYPES.SELECT_PLAN);
  //   } else {
  //     setCurrentComponent(COMPONENT_TYPES.VIEW_MEMBERS);
  //   }
  // }, [props.actionParam]);

  useEffect(() => {

    if (props.quoteToReCreate) {
      const policyEnteries = props.quoteToReCreate.quotation.policy_schedule_entries

      const tempDep = policyEnteries.map(entry => {
        return {
          ...entry.dependant,
          benefits: entry.benefits.map(benefit => {
            return {
              ...benefit,
              uuid: benefit.additional_details.uuid,
              premium_amount: benefit.additional_details.premium_amount
            }
          }),
          premium_amount_in_cents: entry.premium_amount_in_cents,
          uuid: entry.dependant.additional_details.uuid,
          type: entry.dependant.additional_details.memberType,
        }
      })

      const plan1 = find(props.products, { code: props.quoteToReCreate.quotation.additional_details.primary_plan })
      const plan2 = find(props.products, { code: props.quoteToReCreate.quotation.additional_details.secondary_plan })
      const quoteCoverType = props.quoteToReCreate.quotation.additional_details.cover_type


      console.log('setting plan, parentPlan and coverType: ', props.products, plan1, plan2, quoteCoverType);
      setPlan(plan1)

      setParentsPlan(plan2)
      setCoverType(quoteCoverType)
      setSelectedExtendedBenefit()

      console.log(tempDep);
      console.log(policyEnteries);
      setDependants(tempDep)
      setCurrentComponent(COMPONENT_TYPES.VIEW_MEMBERS)
      // setCurrentComponent(COMPONENT_TYPES.SELECT_PLAN)
      // console.log('actionParam: ', actionParam);
      if (props.actionParam === 'upgrade-downgrade') {
        setCurrentComponent(COMPONENT_TYPES.SELECT_PLAN);
      } else {
        setCurrentComponent(COMPONENT_TYPES.VIEW_MEMBERS);
      }

      setSuspendDuplicateIdCheck(true)
    }
  }, [props.quoteToReCreate])



  const handleAdddependant = () => {
    settogglequoteanddependant(!togglequoteanddependant)
  }


  const removeDependant = (uuid) => {
    const item = find(dependants, { uuid: uuid })
    if (item.relationship === 'Principal') {
      setDependants([])
    } else {
      const updatedDependants = dependants.filter(item => item.uuid !== uuid);
      setDependants(updatedDependants);

      // if its the last extended member, then also remove the initialy set extended member benefit
      if (isExtendedMember(item.relationship)) {
        const extended_members = dependants.filter(member => member.type === 'Extended_2')
        if (extended_members.length === 1) {
          setSelectedExtendedBenefit(null)
        }
      }
    }
  };



  const handleCreateQuote = () => {
    // attachBenefits()
    const payload = {
      "product_guid": selectedPlan ? selectedPlan.guid : 'n/a',
      "product_name": selectedPlan ? selectedPlan.name : 'n/a',
      "product_code": selectedPlan ? selectedPlan.code : 'n/a',
      "branch": "string",
      "customer_guid": props.principal.guid,
      "partner": getPartnerGuid(),
      "lapse_period": 4,
      "lapse_period_granularity": "month",
      "lapse_period_cardinality": 1,
      "premium_granularity": "month",
      "premium_cardinality": 1,
      "policy_schedule_entries": [
        ...dependants
      ],
      additional_details: {
        primary_plan: selectedPlan.code,
        secondary_plan: parentsPlan ? parentsPlan.code : null,
        cover_type: coverType,
        extended_members_benefit: selectedExtendedBenefit,

      }
    }
    props.createQuote(payload)

    posthog.capture('clicked_create_quote_btn_monamodi', {
      email: `${getUserEmail()}`,
      name: `${getUserFullname()}`,
      partner: `${getPartnerGuid()}`,
      timestamp: new Date().toLocaleString(),
    });
  }
  const handleQuoteCreatedSuccessfully = () => {
    props.resetAddQuoteSuccessAlert();
    posthog.capture('create_quote_success_monamodi', {
      email: `${getUserEmail()}`,
      name: `${getUserFullname()}`,
      partner: `${getPartnerGuid()}`,
      timestamp: new Date().toLocaleString(),
    });
  }

  const handleQuoteCreateError = () => {
    props.resetAddQuoteErrorAlert();
    posthog.capture('create_quote_error_monamodi', {
      email: `${getUserEmail()}`,
      name: `${getUserFullname()}`,
      partner: `${getPartnerGuid()}`,
      timestamp: new Date().toLocaleString(),
    });
  }

  const handlenextStep = () => {
    props.handleNext();
  }


  const nuclear = selectedPlan ? selectedPlan.membership_configs.content.nuclear.map(item => item.relationship) : [];


  const extended = selectedPlan ? selectedPlan.membership_configs.content.extended.map(item => item.relationship) : [];
  const relationships = [
    'Nuclear', ...nuclear,
    'Extended', ...extended
  ]

  const getMemberConfig = (relationship) => {

    if (nuclear.includes(relationship)) {
      const res = find(selectedPlan.membership_configs.content.nuclear, { "relationship": relationship })
      res['type'] = nuclear
      return res
    }

    if (extended.includes(relationship)) {
      const res = find(selectedPlan.membership_configs.content.extended, { "relationship": relationship })
      res['type'] = extended
      return res
    }

    return null
  }

  const countRelationships = (relationship) => {
    const count = dependants.reduce((total, member) => {
      if (member.relationship === relationship) {
        return total + 1;
      }
      return total;
    }, 0);

    return count;
  }

  // Only Principal/Spouse/Child are billed under the flat family premium. A plan's `nuclear`
  // config array can also list additional named relationships (e.g. Father, Mother_In_Law)
  // that are eligible for cover but must still be priced as parent-tier members (flat
  // per-parent premium, age-matched benefit) — same as anything configured under `extended`.
  const CORE_NUCLEAR_RELATIONSHIPS = ['Principal', 'Spouse', 'Child']

  const getMemberType = (relationship) => {
    if (CORE_NUCLEAR_RELATIONSHIPS.includes(relationship)) return 'Nuclear'
    if (nuclear.includes(relationship)) return 'Extended'
    if (extended.includes(relationship)) return 'Extended'
    return 'N/A'
  }

  const getExtendedMemberConfig = (dateOfBirth) => {
    const age = getAge(dateOfBirth);

    const product = parentsPlan ? parentsPlan : selectedPlan
    const extendedPremiums = product.membership_configs
      ? (product.membership_configs.content.premiums ? product.membership_configs.content.premiums : [])
      : []

    const config = extendedPremiums.find((premium) => {
      return age >= premium.entry_age && age <= premium.exit_age;
    });

    if (config) {
      return config;
    } else {
      return 0;
    }
  };



  const currencyCode = getPartner().country.currency_code


  return (
    <>
      {currentComponent === COMPONENT_TYPES.SELECT_COVER_TYPE &&
        <SelectCoverType
          coverType={coverType}
          setCoverType={setCoverType}
          customerGuid={props.principal.guid}
        />
      }

      {currentComponent === COMPONENT_TYPES.SELECT_PLAN &&
        <SelectPlan
          coverType={coverType}
          hasParentsPlan={hasParentsPlan}
          plans={props.products}
          selectedPlan={selectedPlan}
          setParentsPlan={setParentsPlan}
          setPlan={setPlan}
          parentsPlan={parentsPlan}
        />
      }

      {currentComponent === COMPONENT_TYPES.SELECT_RELATIONSHIP &&
        <SelectRelationship
          hasParentsPlan={hasParentsPlan}
          setHasParentsPlan={setHasParentsPlan}
          selectedPlan={selectedPlan}
          parentsPlan={parentsPlan}
          currentRelationShip={currentRelationShip}
          setCurrentRelationShip={setCurrentRelationShip}
          dependants={dependants}
          setCurrentComponent={setCurrentComponent}
          COMPONENT_TYPES={COMPONENT_TYPES}
          viewMembers={() => setCurrentComponent(COMPONENT_TYPES.VIEW_MEMBERS)}
          coverType={coverType}
          lastSelectedExtendedRelationship={lastSelectedExtendedRelationship}
          setLastSelectedExtendedRelationship={setLastSelectedExtendedRelationship}
          memberRelationshipType={memberRelationshipType}

          actionParam={props.actionParam}
        />
      }

      {currentComponent === COMPONENT_TYPES.ADD_DEPENDANT &&
        <Adddependant
          coverType={coverType}
          agentUsersData={props.agentUsersData}
          dependant={props.dependant}
          handleCreateQuote={handleCreateQuote}
          handleAdddependant={handleAdddependant}
          createQuote={props.createQuote}
          setDependants={setDependants}
          dependants={dependants}
          createDependant={props.createDependant}
          viewMembers={() => setCurrentComponent(COMPONENT_TYPES.VIEW_MEMBERS)}

          setLastSelectedExtendedRelationship={setLastSelectedExtendedRelationship}

          currencyCode={currencyCode}
          removeDependant={removeDependant}
          depAlert={depAlert}
          setDepAlert={setDepAlert}
          principal={props.principal}
          autoFillPrincipal={props.autoFillPrincipal}
          toggleAutoFillPrincipal={props.toggleAutoFillPrincipal}
          selectedPlan={selectedPlan}
          parentsPlan={parentsPlan}
          relationships={relationships}
          getMemberConfig={getMemberConfig}
          countRelationships={countRelationships}
          getMemberType={getMemberType}
          getExtendedMemberConfig={getExtendedMemberConfig}
          currentRelationShip={currentRelationShip}
          selectedExtendedBenefit={selectedExtendedBenefit}
          setSelectedExtendedBenefit={setSelectedExtendedBenefit}

          memberRelationshipType={memberRelationshipType}
          suspendDuplicateIdCheck={suspendDuplicateIdCheck}

        />
      }

      {currentComponent === COMPONENT_TYPES.VIEW_MEMBERS &&
        <ViewMembers
          currencyCode={currencyCode}
          removeDependant={removeDependant}
          dependants={dependants}
          addAnotherMember={(relationshipType) => {
            setMemberRelationshipType(relationshipType)
            setCurrentComponent(COMPONENT_TYPES.SELECT_RELATIONSHIP)
            setCurrentRelationShip(null)
          }}
          setOpenAddBenefitsDialog={setOpenAddBenefitsDialog}
          coverType={coverType}
          additionalBenefits={additionalBenefits}
          selectedPlan={selectedPlan}
          parentsPlan={parentsPlan}
        />
      }

      <AddBenefits
        currencyCode={currencyCode}
        setOpenAddBenefitsDialog={setOpenAddBenefitsDialog}
        openAddBenefitsDialog={openAddBenefitsDialog}
        selectedPlan={selectedPlan}
        parentsPlan={parentsPlan}
        dependants={dependants}
        setDependants={setDependants}
        additionalBenefits={additionalBenefits}
        setAdditionalBenefits={setAdditionalBenefits}
      />

      {
        props.actionParam === 'upgrade-downgrade' ? null : (
          <NavButtons
            currentComponent={currentComponent}
            setCurrentComponent={setCurrentComponent}
            coverType={coverType}
            selectedPlan={selectedPlan}
            setPlan={setPlan}
            hasParentsPlan={hasParentsPlan}
            parentsPlan={parentsPlan}
            setParentsPlan={setParentsPlan}
            actionParam={props.actionParam}
          />
        )
      }




      <AlertDialog
        custom
        show={props.showAddQuoteProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2> Creating Quote...</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={props.showAddQuoteSuccessAlert}
        size="sm"
        title={'Quote  created'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handleQuoteCreatedSuccessfully() }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        confirmBtnCssClass
      >
        <div >
          <Button variant="contained" onClick={() => { handlenextStep() }} style={{ background: 'green', }}>View Quote Details</Button>
        </div>
      </AlertDialog>

      <AlertDialog
        show={props.showAddQuoteErrorAlert}
        danger
        title={'Error creating Quote'}
        onConfirm={() => handleQuoteCreateError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        {
          props.createQuoteError ? props.createQuoteError.message : ""
        }
      </AlertDialog>

      <hr />
      {selectedPlan &&
        <>
          {dependants.length > 0 &&
            <div className={classes.createquote}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleCreateQuote}
              >
                Create Quote
              </Button>
            </div>
          }
        </>
      }




    </>
  )
}

export default CreateQuoteMonamodi

function getAge(dateOfBirth) {
  const birthDate = new Date(dateOfBirth);
  const currentDate = new Date();

  const age = currentDate.getFullYear() - birthDate.getFullYear();
  return age;

}
